export var structureAndContentRelativePath = function (locale, brandId) { return brandId ? "/helpcenter/" + locale + "/contentAndStructure?brandId=" + brandId : "/helpcenter/" + locale + "/contentAndStructure"; };
export var createStructureAndContentApi = function (baseUrl, http) {
    var apiUrl = function (locale, brandId) { return baseUrl + structureAndContentRelativePath(locale, brandId); };
    return {
        get: function (dto) {
            return http.get(apiUrl(dto.locale, dto.brandId));
        },
        updatePageAndSidebar: function (dto) {
            return dto.brandId ? http.put(apiUrl(dto.locale) + "/pageAndSidebar?brandId=" + dto.brandId, dto) : http.put(apiUrl(dto.locale) + "/pageAndSidebar", dto);
        },
        updateHeader: function (dto) {
            return dto.brandId ? http.put(apiUrl(dto.locale) + "/header?brandId=" + dto.brandId, dto) : http.put(apiUrl(dto.locale) + "/header", dto);
        },
        updateFooter: function (dto) {
            return dto.brandId ? http.put(apiUrl(dto.locale) + "/footer?brandId=" + dto.brandId, dto) : http.put(apiUrl(dto.locale) + "/footer", dto);
        },
    };
};
//# sourceMappingURL=index.js.map